import { createPluginFactory } from '@udecode/plate-common';

import { ELEMENT_INLINE_IMAGE } from '../../plateTypes';

export { ELEMENT_INLINE_IMAGE };

/** Enables support for inline images. */
export const createInlineImagePlugin = createPluginFactory({
  key: ELEMENT_INLINE_IMAGE,
  isElement: true,
  isInline: true,
  isVoid: true,
  deserializeHtml: {
    rules: [{ validNodeName: 'IMG' }],
    getNode(el) {
      // Check to see if the element has a parent element with text content.
      const pEl = el.parentElement;
      if (!pEl) return undefined;
      if ((pEl.textContent ?? '').trim().length === 0) return undefined;

      return {
        type: ELEMENT_INLINE_IMAGE,
        url: el.getAttribute('src'),
        children: [{ text: '' }],
      };
    },
  },
});
